<template>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label>แท็ก (tags) ในเนื้อหาภาษา {{language.code}}</label>
                <multi-select 
                    :options="tags" 
                    :selected-options="selected_options" 
                    class="form-control"   
                    placeholder="select item"
                    @select="onSelectTag"
                    @searchchange="searchTags"
                ></multi-select>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelSelect } from 'vue-search-select'; 
import { MultiSelect  } from 'vue-search-select';
export default {
    props:{
        language:[],
        tags:[],
        selected:[]
    },
    name:'SelectTags',
    components: {
        ModelSelect,
        MultiSelect,        
    },    
    data(){
        return {            
            selected_options:[]
        }
    },
    mounted() {
        //console.log('Component mounted.')            
        this.selected_options = this.selected
        // console.log('selected', this.selected)
    },
    created(){
        // console.log(this.tags);            
        // this.selected_options = this.selected
        // console.log('selected', this.selected)
    },
    methods:{        
        onSelectTag (items, lastSelectItem) {     
            // console.log('selected', this.selected)           
            this.selected_options = items                
            this.lastSelectTag = lastSelectItem
            this.language.tags = this.selected_options;
            // console.log("this.tags",this.tags);
        },            
        reset () {
            // this.tags = {}
        },
        selectFromParentComponent1 () {
            // select option from parent component
            // this.tags = this.options[0]
        },
        reset2 () {
            this.item2 = ''
        },
        selectFromParentComponent2 () {
            // select option from parent component
            // this.item2 = this.options2[0].value
        },
        searchTags(searchText){
            this.$emit('searchTags', searchText);
        }
    }
    
}
</script>